<template>
	<div class="repair-management">
		<el-card>
			<div slot="header" class="clearfix">
				<span>服务预约管理</span>
				<el-button-group style="float: right;">
					<el-dropdown @command="handleExportCommand">
						<el-button type="primary" style="border-radius: 0px;">
							导出数据<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="selected">导出勾选</el-dropdown-item>
							<el-dropdown-item command="today">导出今日</el-dropdown-item>
							<el-dropdown-item command="dateRange">选择日期</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-button-group>
			</div>

			<el-row :gutter="20" class="filter-row">
				<el-col :span="6">
					<el-input v-model="filter.keyword" placeholder="搜索单号/联系人/电话" clearable @clear="fetchRepairList"
						@keyup.enter.native="fetchRepairList">
						<el-button slot="append" icon="el-icon-search" @click="fetchRepairList"></el-button>
					</el-input>
				</el-col>
				<!-- <el-col :span="6">
					<el-select v-model="filter.company_id" placeholder="按公司筛选" clearable @change="fetchRepairList">
						<el-option v-for="company in companyList" :key="company.id" :label="company.name"
							:value="company.id"></el-option>
					</el-select>
				</el-col> -->
				<el-col :span="6">
					<el-select v-model="filter.status" placeholder="按状态筛选" clearable @change="fetchRepairList">
						<el-option label="全部状态" value=""></el-option>
						<el-option label="待处理" :value="0"></el-option>
						<el-option label="处理中" :value="1"></el-option>
						<el-option label="已完成" :value="2"></el-option>
						<el-option label="已取消" :value="3"></el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-table :data="repairList" border style="width: 100%" v-loading="loading"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column prop="request_no" label="报修单号"></el-table-column>
				<el-table-column prop="company_id" label="公司" width="150"></el-table-column>
				<!-- <el-table-column prop="user_name" label="提交人" width="120"></el-table-column> -->
				<el-table-column prop="contact_person" label="联系人" width="120"></el-table-column>
				<el-table-column prop="contact_phone" label="联系电话" width="120"></el-table-column>
				<el-table-column prop="model" label="仪器型号" width="120"></el-table-column>
				<el-table-column prop="serial_number" label="仪器序列号" width="120"></el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="getStatusTag(scope.row.status)">
							{{ getStatusName(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="上报时间">
					<template slot-scope="scope">
						{{ scope.row.created_at | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="250" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleDetail(scope.row)">详情</el-button>
						<el-button size="mini" :type="getStatusTag(scope.row.status)"
							@click="handleUpdate(scope.row.id)"
							v-if="scope.row.status < 2">{{getStatusText(scope.row.status)}}</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row.id)"
							v-if="scope.row.status < 2 && userRole == 0">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>

		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="resetForm"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
				<el-form-item label="公司" prop="company_id" v-if="isAdmin">
					<el-select v-model="form.company_id" placeholder="请选择公司">
						<el-option v-for="company in companyList" :key="company.id" :label="company.name"
							:value="company.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系人" prop="contact_person">
					<el-input v-model="form.contact_person"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="contact_phone">
					<el-input v-model="form.contact_phone"></el-input>
				</el-form-item>
				<el-form-item label="电子邮箱">
					<el-input v-model="form.email"></el-input>
				</el-form-item>
				<el-form-item label="职务">
					<el-input v-model="form.job_title"></el-input>
				</el-form-item>
				<el-form-item label="仪器型号" prop="instrument_model">
					<el-input v-model="form.instrument_model"></el-input>
				</el-form-item>
				<el-form-item label="序列号">
					<el-input v-model="form.serial_number"></el-input>
				</el-form-item>
				<el-form-item label="问题描述" prop="problem_description">
					<el-input type="textarea" :rows="4" v-model="form.problem_description"></el-input>
				</el-form-item>
				<el-form-item label="附件">
					<el-upload class="upload-demo" :action="uploadUrl" :on-success="handleUploadSuccess"
						:before-upload="beforeUpload" :on-remove="handleRemove" :file-list="fileList" multiple
						list-type="picture-card">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">可上传图片或文档，大小不超过5MB</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="状态" v-if="isEdit && isAdmin">
					<el-select v-model="form.status" placeholder="请选择状态">
						<el-option label="待处理" :value="0"></el-option>
						<el-option label="处理中" :value="1"></el-option>
						<el-option label="已完成" :value="2"></el-option>
						<el-option label="已取消" :value="3"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 详情对话框 -->
		<el-dialog title="报修单详情" :visible.sync="detailVisible" width="60%">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="报修单号">{{ currentRepair.request_no }}</el-descriptions-item>
				<el-descriptions-item label="公司">{{ currentRepair.company_id }}</el-descriptions-item>
				<!-- <el-descriptions-item label="提交人">{{ currentRepair.user_name }}</el-descriptions-item> -->
				<el-descriptions-item
					label="提交时间">{{ currentRepair.created_at | formatDateTime }}</el-descriptions-item>
				<el-descriptions-item label="联系人">{{ currentRepair.contact_person }}</el-descriptions-item>
				<el-descriptions-item label="联系电话">{{ currentRepair.contact_phone }}</el-descriptions-item>
				<el-descriptions-item label="电子邮箱">{{ currentRepair.email || '-' }}</el-descriptions-item>
				<el-descriptions-item label="职务">{{ currentRepair.job_title || '-' }}</el-descriptions-item>
				<el-descriptions-item label="仪器型号">{{ currentRepair.model }}</el-descriptions-item>
				<el-descriptions-item label="序列号">{{ currentRepair.serial_number || '-' }}</el-descriptions-item>

				<el-descriptions-item label="状态" :span="2">
					<el-tag :type="getStatusTag(currentRepair.status)">
						{{ getStatusName(currentRepair.status) }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="问题描述" :span="2">
					{{ currentRepair.service_description }}
				</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showShareDialog">分 享</el-button>
				<el-button @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="分享预约服务单" :visible.sync="shareDialogVisible" width="400px">
			<div class="share-container">
				<div class="share-link">
					<el-input v-model="shareLink" readonly>
						<el-button slot="append" icon="el-icon-document-copy" @click="copyShareLink"
							v-clipboard:copy="shareLink" v-clipboard:success="onCopySuccess"
							v-clipboard:error="onCopyError">
						</el-button>
					</el-input>
				</div>

				<div class="access-code-section">
					<p class="access-code-label">访问码</p>
					<span class="access-code">{{ accessCode }}</span>
				</div>

				<div class="qrcode-container">
					<canvas ref="qrcodeCanvas" class="qrcode-canvas"></canvas>
					<p class="qrcode-tip">扫描二维码访问预约服务单</p>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="shareDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		<el-dialog title="选择日期范围" :visible.sync="dateRangeDialogVisible" width="30%">
			<el-date-picker v-model="exportDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%">
			</el-date-picker>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dateRangeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="exportByDateRange">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';
	import QRCode from 'qrcode'

	export default {
		filters: {
			formatDateTime(value) {
				if (!value) return '-';
				const date = new Date(value);
				return date.toLocaleString();
			}
		},
		computed: {
			hasOtherFiles() {
				return this.currentRepair.attachments.some(file =>
					!this.isImageFile(file) && !this.isVideoFile(file)
				);
			}
		},
		data() {
			return {
				loading: false,
				repairList: [],
				companyList: [],
				filter: {
					keyword: '',
					company_id: '',
					status: ''
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				dialogVisible: false,
				detailVisible: false,
				dialogTitle: '新建报修',
				currentRepair: {},
				form: {
					id: '',
					company_id: '',
					contact_person: '',
					contact_phone: '',
					email: '',
					job_title: '',
					instrument_model: '',
					serial_number: '',
					problem_description: '',
					status: 0,
					attachments: []
				},
				fileList: [],
				rules: {
					company_id: [{
						required: true,
						message: '请选择公司',
						trigger: 'change'
					}],
					contact_person: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					contact_phone: [{
							required: true,
							message: '请输入联系电话',
							trigger: 'blur'
						},
						{
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur'
						}
					],
					instrument_model: [{
						required: true,
						message: '请输入仪器型号',
						trigger: 'blur'
					}],
					problem_description: [{
						required: true,
						message: '请输入问题描述',
						trigger: 'blur'
					}]
				},
				isEdit: false,
				isAdmin: false, // 根据实际用户角色设置
				uploadUrl: `${apiBaseUrl}/api/upload.php`,
				multipleSelection: [], // 存储勾选的行数据
				dateRangeDialogVisible: false, // 日期范围对话框显示状态
				exportDateRange: [], // 导出的日期范围
				shareDialogVisible: false,
				shareLink: '',
				accessCode: '',
				userRole: 1
			};
		},
		created() {
			this.checkUserRole();
			this.fetchRepairList();
		},
		methods: {
			checkUserRole() {
				// 这里根据实际业务逻辑判断用户是否是管理员
				// this.isAdmin = this.$store.getters.role === 2;
				this.isAdmin = true; // 临时设置为true方便测试
				const userInfo = JSON.parse(localStorage.getItem('token') || '{}');
				this.userRole = userInfo.role;
			},

			getStatusTag(status) {
				const map = {
					0: 'warning', // 待处理
					1: 'primary', // 处理中
					2: 'success', // 已完成
					3: 'danger' // 已取消
				};
				return map[status] || '';
			},
			getStatusText(status) {
				const map = {
					0: '去处理', // 待处理
					1: '确认完成', // 处理中
				};
				return map[status] || '';
			},

			getStatusName(status) {
				const map = {
					0: '待处理',
					1: '处理中',
					2: '已完成',
					3: '已取消'
				};
				return map[status] || '';
			},

			isImage(url) {
				if (!url) return false;
				const ext = url.split('.').pop().toLowerCase();
				return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
			},

			async fetchRepairList() {
				this.loading = true;
				try {
					const params = {
						action: 'list',
						page: this.pagination.currentPage,
						pageSize: this.pagination.pageSize,
						...this.filter,
					};

					// 如果不是管理员，只显示自己的报修单
					if (!this.isAdmin) {
						params.user_id = this.$store.getters.userId;
					}

					const response = await fetch(`${apiBaseUrl}/service.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(params),
					});

					const data = await response.json();

					if (data.success) {
						this.repairList = data.data;
						this.pagination.total = parseInt(data.total);
					} else {
						throw new Error(data.message || '获取报修列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
				} finally {
					this.loading = false;
				}
			},

			async fetchCompanyList() {
				try {
					// 假设有一个获取公司列表的接口
					const response = await fetch(`${apiBaseUrl}/companies.php?action=list`);
					const data = await response.json();

					if (data.success) {
						this.companyList = data.data;
						// 设置默认公司（如果不是管理员）
						if (!this.isAdmin && this.companyList.length > 0) {
							this.form.company_id = this.companyList[0].id;
						}
					} else {
						throw new Error(data.message || '获取公司列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
				}
			},

			showAddDialog() {
				this.dialogTitle = '新建报修';
				this.isEdit = false;
				this.resetForm();
				this.dialogVisible = true;
			},

			handleDetail(row) {
				this.currentRepair = row;
				this.detailVisible = true;
			},

			handleEdit(row) {
				this.dialogTitle = '编辑报修单';
				this.isEdit = true;
				this.form = {
					id: row.id,
					company_id: row.company_id,
					contact_person: row.contact_person,
					contact_phone: row.contact_phone,
					email: row.email,
					job_title: row.job_title,
					instrument_model: row.instrument_model,
					serial_number: row.serial_number,
					problem_description: row.problem_description,
					status: row.status,
					attachments: row.attachments || []
				};
				this.fileList = this.form.attachments.map(file => ({
					name: file.name,
					url: file.url
				}));
				this.dialogVisible = true;
			},
			async handleUpdate(id) {
				const response = await fetch(`${apiBaseUrl}/updateStatus.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						id,
						type: 'service'
					}),
				});
				const data = await response.json();
				console.log(data)
				if (data.code == 200) {
					this.fetchRepairList();
				} else {
					throw new Error(data.message || '修改失败');
				}
			},

			async submitForm() {
				this.$refs.form.validate(async (valid) => {
					if (!valid) return;

					try {
						let params = {
							...this.form
						};
						params.action = this.isEdit ? 'update' : 'add';
						params.attachments = this.fileList.map(file => ({
							name: file.name,
							url: file.url
						}));

						const response = await fetch(`${apiBaseUrl}/service.php`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(params),
						});

						const data = await response.json();

						if (data.success) {
							this.$message.success(this.isEdit ? '修改成功' : '添加成功');
							this.dialogVisible = false;
							this.fetchRepairList();
						} else {
							throw new Error(data.message || (this.isEdit ? '修改失败' : '添加失败'));
						}
					} catch (error) {
						this.$message.error(error.message);
					}
				});
			},

			async handleDelete(id) {
				try {
					await this.$confirm('确定要删除该报修单吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/service.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'delete',
							id
						}),
					});

					const data = await response.json();

					if (data.success) {
						this.$message.success('删除成功');
						this.fetchRepairList();
					} else {
						throw new Error(data.message || '删除失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},

			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.fetchRepairList();
			},

			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.fetchRepairList();
			},

			resetForm() {
				this.form = {
					id: '',
					company_id: this.companyList.length > 0 ? this.companyList[0].id : '',
					contact_person: '',
					contact_phone: '',
					email: '',
					job_title: '',
					instrument_model: '',
					serial_number: '',
					problem_description: '',
					status: 0,
					attachments: []
				};
				this.fileList = [];
				if (this.$refs.form) {
					this.$refs.form.resetFields();
				}
			},

			handleUploadSuccess(response, file, fileList) {
				if (response.success) {
					this.fileList = fileList.map(f => ({
						name: f.name,
						url: f.response ? f.response.data.url : f.url
					}));
				} else {
					this.$message.error(response.message || '上传失败');
				}
			},

			handleRemove(file, fileList) {
				this.fileList = fileList.map(f => ({
					name: f.name,
					url: f.response ? f.response.data.url : f.url
				}));
			},

			beforeUpload(file) {
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('上传文件大小不能超过 5MB!');
				}
				return isLt5M;
			},
			isImageFile(file) {
				const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
				const ext = file.file_path.split('.').pop().toLowerCase();
				return imageTypes.includes(ext) ||
					(file.file_type && file.file_type.startsWith('image/'));
			},

			// 判断是否为视频文件
			isVideoFile(file) {
				const videoTypes = ['mp4', 'webm', 'ogg', 'mov', 'avi'];
				const ext = file.file_path.split('.').pop().toLowerCase();
				return videoTypes.includes(ext) ||
					(file.file_type && file.file_type.startsWith('video/'));
			},

			// 获取预览列表（按类型筛选）
			getPreviewList(type) {
				return this.currentRepair.attachments
					.filter(file =>
						type === 'image' ? this.isImageFile(file) : this.isVideoFile(file)
					)
					.map(f => 'http://service.fossnet.cn/api/' + f.file_path);
			},

			// 获取文件类型图标
			getFileIcon(file) {
				const ext = file.file_name ? file.file_name.split('.').pop().toLowerCase() : '';
				const iconMap = {
					pdf: 'el-icon-document',
					doc: 'el-icon-document',
					docx: 'el-icon-document',
					xls: 'el-icon-document',
					xlsx: 'el-icon-document',
					ppt: 'el-icon-document',
					pptx: 'el-icon-document',
					zip: 'el-icon-folder-opened',
					rar: 'el-icon-folder-opened',
					txt: 'el-icon-document',
					default: 'el-icon-document'
				};
				return iconMap[ext] || iconMap.default;
			},
			getVideoPoster(file) {
				return file.poster_path ? 'http://service.fossnet.cn/api/' + file.poster_path : '';
			},

			// 格式化文件大小
			formatFileSize(bytes) {
				if (!bytes) return '0 B';
				const k = 1024;
				const sizes = ['B', 'KB', 'MB', 'GB'];
				const i = Math.floor(Math.log(bytes) / Math.log(k));
				return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 处理导出命令
			handleExportCommand(command) {
				switch (command) {
					case 'selected':
						this.exportSelected();
						break;
					case 'today':
						this.exportToday();
						break;
					case 'dateRange':
						this.showDateRangeDialog();
						break;
				}
			},

			// 导出勾选的数据
			async exportSelected() {
				if (this.multipleSelection.length === 0) {
					this.$message.warning('请至少选择一条数据');
					return;
				}

				const ids = this.multipleSelection.map(item => item.id);

				this.loading = true;
				const response = await fetch(`${apiBaseUrl}/exportService.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						action: 'export',
						type: 'selected',
						ids: ids
					}),
				});
				const data = await response.json();
				console.log(data)
				// .then(response => response.json())
				// .then(data => {
				if (data.success) {
					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = data.download_url;
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.loading = false;
					this.$message.success(`成功导出 ${data.count} 条数据`);
				} else {
					this.loading = false;
					this.$message.error(data.message);
				}
			},

			// 导出今日数据
			async exportToday() {
				this.loading = true;
				const response = await fetch(`${apiBaseUrl}/exportService.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						action: 'export',
						type: 'today'
					}),
				})
				const data = await response.json();
				console.log(data)
				// .then(response => response.json())
				// .then(data => {
				if (data.success) {
					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = data.download_url;
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.loading = false;
					this.$message.success(`成功导出 ${data.count} 条数据`);
				} else {
					this.loading = false;
					this.$message.error(data.message);
				}
			},

			// 显示日期范围选择对话框
			showDateRangeDialog() {
				this.dateRangeDialogVisible = true;
			},

			// 按日期范围导出
			async exportByDateRange() {
				if (!this.exportDateRange || this.exportDateRange.length !== 2) {
					this.$message.warning('请选择完整的日期范围');
					return;
				}

				const [startDate, endDate] = this.exportDateRange;

				this.loading = true;
				const response = await fetch(`${apiBaseUrl}/exportService.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						action: 'export',
						type: 'date_range',
						start_date: startDate,
						end_date: endDate
					}),
				})
				const data = await response.json();
				console.log(data)
				// .then(response => response.json())
				// .then(data => {
				if (data.success) {
					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = data.download_url;
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.loading = false;
					this.$message.success(`成功导出 ${data.count} 条数据`);
				} else {
					this.loading = false;
					this.$message.error(data.message);
				}
			},
			async showShareDialog() {
				this.accessCode = await this.generateAccessCode();
				// 生成分享链接
				// const baseUrl = window.location.origin;
				const baseUrl = 'https://www.fossnet.cn/#';
				const sharePath = `/share-page?type=service&id=${this.currentRepair.id}`;
				this.shareLink = baseUrl + sharePath;

				// 显示对话框
				this.shareDialogVisible = true;

				// 等待DOM更新后生成二维码
				await this.$nextTick();
				this.generateQRCode();
			},

			// 生成二维码
			generateQRCode() {
				try {
					const canvas = this.$refs.qrcodeCanvas;
					QRCode.toCanvas(canvas, this.shareLink, {
						width: 200,
						margin: 2,
						color: {
							dark: '#000000',
							light: '#ffffff'
						}
					}, (error) => {
						if (error) {
							console.error('生成二维码失败:', error);
							this.$message.error('生成二维码失败');
						}
					});
				} catch (error) {
					console.error('二维码生成异常:', error);
					this.$message.error('生成二维码时出错');
				}
			},

			// 复制分享链接
			copyShareLink() {
				// 使用clipboard指令实现，不需要额外代码
			},

			onCopySuccess() {
				this.$message.success('链接已复制到剪贴板');
			},

			onCopyError() {
				this.$message.error('复制链接失败');
			},
			async generateAccessCode() {
				const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
				let result = '';
				for (let i = 0; i < 4; i++) {
					result += chars.charAt(Math.floor(Math.random() * chars.length));
				}

				try {
					const response = await fetch(`${apiBaseUrl}/getAccessCode.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							id: this.currentRepair.id,
							type: 'service',
							code: result
						}),
					});

					const data = await response.json();
					if (data.code == 200) {
						return data.data.code; // 返回实际的code值
					} else {
						throw new Error("获取访问码失败");
					}
				} catch (error) {
					console.error('生成访问码错误:', error);
					return "网络错误";
				}
			},
		}
	};
</script>

<style scoped>
	.repair-management {
		/* padding: 20px; */
	}

	.filter-row {
		margin-bottom: 20px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.el-descriptions {
		margin-top: 20px;
	}

	.el-image {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.attachment-container {
		width: 100%;
	}

	.media-container {
		display: flex;
		flex-wrap: wrap;
		gap: 15px;
		margin-bottom: 15px;
	}

	.media-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 140px;
	}

	.media-content {
		width: 100%;
		height: 100px;
		border-radius: 4px;
		object-fit: cover;
		background-color: #f5f7fa;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #909399;
		font-size: 24px;
		cursor: pointer;
		transition: all 0.3s;
		border: 1px solid #ebeef5;
	}

	.media-content:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.media-name {
		margin-top: 5px;
		font-size: 12px;
		color: #606266;
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: center;
	}

	.file-list {
		border-top: 1px dashed #e6e6e6;
		padding-top: 10px;
	}

	.file-item {
		display: flex;
		align-items: center;
		padding: 8px 10px;
		margin-bottom: 5px;
		border-radius: 4px;
		transition: all 0.3s;
		width: 100%;
	}

	.file-item:hover {
		background-color: #f5f7fa;
	}

	.file-item i {
		margin-right: 8px;
		font-size: 18px;
		color: #606266;
	}

	.file-name {
		flex: 1;
		margin-right: 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.file-size {
		font-size: 12px;
		color: #909399;
	}

	.image-slot {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		background: #f5f7fa;
		color: #909399;
	}

	.clearfix:after {
		content: "";
		display: table;
		clear: both;
	}

	.share-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
	}

	.share-link {
		width: 100%;
		margin-bottom: 20px;
	}

	.qrcode-container {
		text-align: center;
		margin-top: 15px;
	}

	.qrcode-canvas {
		border: 1px solid #eee;
		padding: 10px;
		background: white;
	}

	.qrcode-tip {
		margin-top: 10px;
		color: #666;
		font-size: 14px;
	}

	.access-code {
		font-size: 40px;
		color: #409EFF;
		letter-spacing: 20px;
	}

	.access-code-label {
		font-size: 18px;
		text-align: center;
		letter-spacing: 6px;
		font-weight: lighter;
	}
</style>